import CssBaseline from "@mui/material/CssBaseline";
import React, { Component } from "react";
import "../App.css";
import Appbar from "./Appbar.js";
import UserSessionTimeoutSnackbar from "./UserSessionTimeoutSnackbar";
import WebSocketHandler from "./WebSocketHandler";
import { removeAuthCodeFromQueryString } from "../util/authentication.js";

export class ActiveUserSession extends Component {
  componentDidMount() {
    removeAuthCodeFromQueryString();
  }

  render() {
    return (
      <div className="root">
        <CssBaseline />
        <UserSessionTimeoutSnackbar />
        <WebSocketHandler />
        <Appbar />
      </div>
    );
  }
}

export default ActiveUserSession;
